import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { MainFooter } from "./MainFooter";
import { Navigation } from "./Navigation";

const LayoutContainer = styled.div`
	height: 100vh;
	display: flex;
	flex-direction: row;
	background-color: #ebeefd;
	overflow: hidden;
`;

const SidebarContainer = styled.div`
	width: 80px;
	min-height: 100vh;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1000;
`;

const ContentContainer = styled.main`
	flex: 1;
	margin-left: 80px;
	overflow-y: auto;
	scrollbar-gutter: stable;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: #ebeefd;

	@media (max-width: 768px) {
		padding: 16px 16px 0;
		margin-left: 80px;
	}

	@media (max-width: 480px) {
		padding: 12px 12px 0;
		margin-left: 80px;
	}
`;

const ContentBody = styled.div`
	flex: 1 0 auto;
	margin-bottom: 64px;

	/* Pin route loaders to the viewport so the icon lines up exactly with the
	   full-page auth loader, independent of the sidebar and scrollbar gutter.
	   The sidebar (z-index 1000) still paints on top. */
	[data-full-page-loader] {
		position: fixed;
		inset: 0;
	}
`;

export const RootLayout = ({ sidebarExtra }: { sidebarExtra?: ReactNode } = {}) => {
	return (
		<LayoutContainer>
			<SidebarContainer>
				<Navigation menuExtra={sidebarExtra} />
			</SidebarContainer>
			<ContentContainer>
				<ContentBody>
					<Outlet />
				</ContentBody>
				<MainFooter />
			</ContentContainer>
		</LayoutContainer>
	);
};
